import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import SuperAdminPage from './pages/SuperAdminPage';
import MyTripsPage from './pages/MyTripsPage';
import EditProfilePage from './pages/EditProfilePage';
import AnalyticsPage from './pages/AnalyticsPage';
import ManageSubscriptionPage from './pages/ManageSubscriptionPage';
import SettingsPage from './pages/SettingsPage';
import HelpPage from './pages/HelpPage';
import LandingPage from './pages/LandingPage';
import TripPlanningPage from './pages/TripPlanningPage';
import ChatHistoryPage from './pages/ChatHistoryPage';
import ContactPage from './pages/ContactPage';
import OAuthCallback from './pages/OAuthCallback';
import { AuthProvider, useAuth } from './context/AuthContext';
import { AlertProvider } from './components/GlobalAlert';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import SecondaryNavbar from './components/SecondaryNavbar';
import LanguageDropdown from './components/LanguageDropdown';
import './App.css';
import './font-size-adjustments.css'; /* เพิ่มการ import ไฟล์ปรับขนาดตัวอักษร */

// Component สำหรับ Navbar
const Navbar = () => {
  const { isAuthenticated, user } = useAuth();
  const { t } = useLanguage();

  return (
    <nav style={navbarStyles.navbar}>
      <div style={navbarStyles.brand}>
        <Link to="/" style={navbarStyles.brandLink}>
          {/* ลบ logo และข้อความ Mellow ออก */}
        </Link>
      </div>
      <ul style={navbarStyles.navList}>
        {!isAuthenticated ? (
          <>
            <li style={navbarStyles.navItem}>
              <Link to="/login" style={navbarStyles.navLink}>
                <span style={navbarStyles.navIcon}>🔑</span>
                {t('login')}
              </Link>
            </li>
            <li style={navbarStyles.navItem}>
              <Link to="/register" style={navbarStyles.navLink}>
                <span style={navbarStyles.navIcon}>✨</span>
                {t('register')}
              </Link>
            </li>
          </>
        ) : (
          <>
            <li style={navbarStyles.navItem}>
              <Link to="/plan-trip" style={navbarStyles.navLink}>
                <span style={navbarStyles.navIcon}>✈️</span>
                {t('planTrip')}
              </Link>
            </li>

            {(user?.role === 'admin' || user?.role === 'superadmin') && (
                            <li style={navbarStyles.navItem}>
                <Link to="/admin" style={navbarStyles.navLink}>
                  <span style={navbarStyles.navIcon}>⚙️</span>
                  {t('admin')}
                </Link>
              </li>
            )}
          </>
        )}
        {/* Language Dropdown */}
        <li style={navbarStyles.navItem}>
          <LanguageDropdown />
        </li>
      </ul>
    </nav>
  );
};

const navbarStyles = {
  navbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.036rem 0.72rem', // เพิ่มจาก 0.54rem เป็น 0.72rem ให้กว้างขึ้น
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    borderBottom: '1px solid rgba(3, 155, 229, 0.1)',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    width: '100%',
    zIndex: 1100,
    boxShadow: '0 2px 20px rgba(3, 155, 229, 0.1)',
    transition: 'all 0.3s ease',
    minHeight: '21px', // เพิ่ม 50% จาก 14px เป็น 21px
  },
  brand: {
    fontSize: '1.08rem', // เพิ่ม 50% จาก 0.72rem เป็น 1.08rem
    fontWeight: 'bold',
  },
  brandLink: {
    color: '#039be5',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: '1px', // คงเดิม
    transition: 'all 0.3s ease',
    padding: '0.018rem 0', // เพิ่ม 50% จาก 0.012rem 0 เป็น 0.018rem 0
  },
  brandIcon: {
    fontSize: '1.08rem', // เพิ่ม 50% จาก 0.72rem เป็น 1.08rem
  },
  brandText: {
    fontSize: '1.08rem', // เพิ่ม 50% จาก 0.72rem เป็น 1.08rem
    fontWeight: 'bold',
  },
  navList: {
    listStyle: 'none',
    display: 'flex',
    margin: 0,
    padding: 0,
    alignItems: 'center',
    gap: '1px', // คงเดิม
  },
  navItem: {
    margin: 0,
  },
  navLink: {
    color: '#333',
    textDecoration: 'none',
    padding: '0.27rem 0.54rem', // เพิ่ม 50% จาก 0.18rem 0.36rem เป็น 0.27rem 0.54rem
    borderRadius: '50px', // เพิ่มความโค้งให้เป็นรูปไข่เหมือนในภาพ
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    gap: '1px', // คงเดิม
    fontSize: '0.8rem', // ลดลงจาก 0.936rem
    fontWeight: 'normal', // เปลี่ยนจาก '500' เป็น 'normal'
    backgroundColor: 'rgba(3, 155, 229, 0.05)',
    border: '1px solid transparent',
    minHeight: '21px', // เพิ่ม 50% จาก 14px เป็น 21px
    minWidth: '120px', // เพิ่ม minWidth เพื่อให้ทุกปุ่มมีขนาดเท่ากัน
    justifyContent: 'center', // จัดให้เนื้อหาอยู่ตรงกลาง
    whiteSpace: 'nowrap', // ป้องกันการขึ้นบรรทัดใหม่
  },
  navIcon: {
    fontSize: '0.81rem', // เพิ่ม 50% จาก 0.54rem เป็น 0.81rem
  },
  navLinkHover: {
    backgroundColor: 'rgba(3, 155, 229, 0.1)',
    borderColor: 'rgba(3, 155, 229, 0.2)',
    transform: 'translateY(-1px)',
  }
};

// 404 Page Component
const NotFoundPage = () => {
  const { t } = useLanguage();
  
  return (
    <div style={{ textAlign: 'center', marginTop: '50px', fontSize: '1.2rem', color: 'red' }}>
      <h2>404 - {t('notFound')}</h2>
      <p>{t('pageNotFound')}</p>
      <Link to="/">{t('goHome')}</Link>
    </div>
  );
};

function App() {
  return (
    <Router>
      <LanguageProvider>
        <AlertProvider>
          <AuthProvider>
            <Navbar />
            <SecondaryNavbar />
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/plan-trip" element={<TripPlanningPage />} />
              <Route path="/chat-history" element={<ChatHistoryPage />} />
              <Route path="/contact" element={<ContactPage />} />
              
              {/* OAuth Callback Routes */}
              <Route path="/auth/google/callback" element={<OAuthCallback />} />
              <Route path="/auth/line/callback" element={<OAuthCallback />} />
                              

              {/* Protected Routes with Layout (Sidebar) */}
              <Route element={<PrivateRoute />}>
                <Route path="/dashboard" element={
                  <Layout>
                    <DashboardPage />
                  </Layout>
                } />
                <Route path="/admin" element={
                  <Layout>
                    <AdminDashboardPage />
                  </Layout>
                } />
                <Route path="/superadmin" element={
                  <Layout>
                    <SuperAdminPage />
                  </Layout>
                } />
                <Route path="/my-trips" element={
                  <Layout>
                    <MyTripsPage />
                  </Layout>
                } />
                <Route path="/edit-profile" element={
                  <Layout>
                    <EditProfilePage />
                  </Layout>
                } />
                <Route path="/analytics" element={
                  <Layout>
                    <AnalyticsPage />
                  </Layout>
                } />
                <Route path="/manage-subscription" element={
                  <Layout>
                    <ManageSubscriptionPage />
                  </Layout>
                } />
                <Route path="/settings" element={
                  <Layout>
                    <SettingsPage />
                  </Layout>
                } />
                <Route path="/help" element={
                  <Layout>
                    <HelpPage />
                  </Layout>
                } />
              </Route>

              {/* Default Route / Landing Page */}
              <Route path="/" element={<LandingPage />} />

              {/* 404 Not Found Page */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </AuthProvider>
        </AlertProvider>
      </LanguageProvider>
    </Router>
  );
}

export default App;